var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKfinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 49,
    viewBox: "0 0 252 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0822 44.162V45.0483H63.5298V45.8717H62.0822V46.8304H63.7205V47.6826H61.001V43.3002H63.7205V44.1524L62.0822 44.162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9348 47.6899L70.0304 46.3467L69.2347 47.6899H68.0065L69.4296 45.4614L67.9756 43.3086H69.2347L70.1252 44.6316L70.9093 43.3086H72.1364L70.7271 45.5179L72.1939 47.6899H70.9348Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7376 45.4155C79.6099 45.6348 79.4206 45.8119 79.1933 45.9247C78.9102 46.0621 78.598 46.1286 78.2836 46.1186H77.6125V47.6919H76.5312V43.3095H78.2836C78.5925 43.3001 78.8994 43.3621 79.1805 43.4906C79.4102 43.5974 79.6022 43.7712 79.7312 43.9892C79.856 44.2122 79.9192 44.4644 79.9144 44.7199C79.917 44.9632 79.8561 45.203 79.7376 45.4155ZM78.6617 45.1258C78.7594 45.0133 78.8133 44.8694 78.8133 44.7205C78.8133 44.5715 78.7594 44.4275 78.6617 44.3151C78.5324 44.2093 78.367 44.1577 78.2005 44.1713H77.6125V45.2696H78.2005C78.367 45.2832 78.5324 45.2316 78.6617 45.1258Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3517 44.162V45.0483H86.7994V45.8717H85.3517V46.8304H86.989V47.6826H84.2705V43.3002H86.989V44.1524L85.3517 44.162Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7509 47.6918L92.8284 46.0375H92.5695V47.6918H91.4883V43.3094H93.2992C93.6074 43.3008 93.9134 43.3628 94.194 43.4905C94.4243 43.5957 94.6171 43.7684 94.7469 43.9858C94.8705 44.1993 94.9342 44.4422 94.9312 44.6889C94.9345 44.9691 94.8466 45.2427 94.6808 45.4686C94.4973 45.7097 94.2374 45.8813 93.9437 45.9554L94.9684 47.6907L93.7509 47.6918ZM92.5684 45.2822H93.2395C93.4014 45.2943 93.5616 45.2427 93.6859 45.1384C93.7377 45.0849 93.7778 45.0212 93.8035 44.9513C93.8292 44.8814 93.8399 44.8069 93.835 44.7325C93.839 44.6601 93.8278 44.5876 93.8021 44.5197C93.7764 44.4518 93.7368 44.3901 93.6859 44.3384C93.5616 44.2341 93.4014 44.1825 93.2395 44.1946H92.5684V45.2822Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.485 43.3086V47.691H99.4033V43.3086H100.485Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.145 44.162V45.0483H107.589V45.8717H106.142V46.8304H107.78V47.6826H105.061V43.3002H107.78V44.1524L106.145 44.162Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.251 47.691H115.17L113.359 44.9874V47.691H112.276V43.3086H113.359L115.17 46.0239V43.3086H116.251V47.691Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.929 44.3354C121.114 44.0018 121.389 43.727 121.723 43.5429C122.076 43.3502 122.474 43.2526 122.876 43.2595C123.36 43.246 123.835 43.3907 124.229 43.6718C124.605 43.9462 124.871 44.3441 124.982 44.7956H123.795C123.714 44.6216 123.583 44.4758 123.419 44.377C123.25 44.2799 123.059 44.2302 122.865 44.2332C122.713 44.2277 122.562 44.2556 122.422 44.3149C122.283 44.3742 122.158 44.4633 122.056 44.5762C121.855 44.8398 121.746 45.1623 121.746 45.4939C121.746 45.8255 121.855 46.148 122.056 46.4116C122.158 46.5244 122.283 46.6136 122.422 46.6729C122.562 46.7321 122.713 46.76 122.865 46.7546C123.059 46.7577 123.251 46.7076 123.419 46.6097C123.583 46.5112 123.714 46.3658 123.795 46.1921H124.982C124.872 46.643 124.605 47.04 124.229 47.3128C123.834 47.5917 123.36 47.7353 122.876 47.7218C122.474 47.729 122.076 47.6309 121.723 47.4374C121.389 47.2546 121.114 46.9809 120.929 46.6481C120.742 46.2913 120.645 45.8945 120.645 45.4917C120.645 45.089 120.742 44.6922 120.929 44.3354Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M130.523 44.162V45.0483H131.97V45.8717H130.523V46.8304H132.16V47.6826H129.441V43.3002H132.16V44.1524L130.523 44.162Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M144.979 43.3086V44.1608H143.808V47.6878H142.726V44.1608H141.555V43.3086H144.979Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.584 47.6918L150.661 46.0375H150.402V47.6918H149.32V43.3094H151.131C151.439 43.3008 151.745 43.3628 152.026 43.4905C152.256 43.596 152.449 43.7687 152.579 43.9858C152.702 44.1996 152.765 44.4423 152.763 44.6889C152.767 44.9691 152.679 45.2428 152.513 45.4686C152.329 45.7094 152.069 45.881 151.776 45.9554L152.8 47.6907L151.584 47.6918ZM150.402 45.2822H151.073C151.234 45.2943 151.395 45.2427 151.519 45.1384C151.57 45.0846 151.61 45.0208 151.636 44.951C151.661 44.8812 151.672 44.8068 151.668 44.7325C151.672 44.6601 151.66 44.5877 151.635 44.5199C151.609 44.452 151.57 44.3902 151.519 44.3384C151.395 44.2341 151.234 44.1825 151.073 44.1946H150.402V45.2822Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.999 46.9166H158.343L158.077 47.691H156.945L158.552 43.3086H159.804L161.41 47.691H160.266L159.999 46.9166ZM159.721 46.0921L159.171 44.4878L158.627 46.0921H159.721Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.666 47.691H168.584L166.773 44.9874V47.691H165.691V43.3086H166.773L168.584 46.0239V43.3086H169.666V47.691Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.978 47.5744C174.734 47.48 174.521 47.32 174.362 47.1121C174.205 46.8988 174.119 46.641 174.118 46.376H175.269C175.276 46.5174 175.337 46.6506 175.44 46.7478C175.546 46.8358 175.682 46.8813 175.819 46.8756C175.954 46.8838 176.087 46.8462 176.198 46.7691C176.243 46.7335 176.28 46.6875 176.305 46.6349C176.329 46.5823 176.341 46.5245 176.338 46.4665C176.34 46.4169 176.331 46.3674 176.313 46.3211C176.295 46.2749 176.267 46.233 176.232 46.1981C176.152 46.1241 176.06 46.0649 175.96 46.0234C175.81 45.9631 175.657 45.9109 175.501 45.8668C175.26 45.7976 175.026 45.71 174.799 45.6048C174.614 45.5152 174.453 45.3826 174.33 45.2181C174.192 45.0231 174.123 44.7877 174.134 44.5491C174.126 44.3649 174.163 44.1815 174.241 44.0145C174.319 43.8475 174.437 43.702 174.584 43.5904C174.924 43.3463 175.337 43.2243 175.755 43.2442C176.177 43.2238 176.593 43.3458 176.937 43.5904C177.085 43.7043 177.205 43.8502 177.288 44.0172C177.372 44.1841 177.416 44.3678 177.418 44.5544H176.247C176.245 44.4908 176.23 44.4282 176.203 44.3707C176.176 44.3132 176.136 44.2622 176.088 44.221C175.982 44.1367 175.85 44.0932 175.715 44.0985C175.599 44.0925 175.485 44.1305 175.395 44.205C175.351 44.2476 175.317 44.3 175.297 44.3581C175.276 44.4161 175.27 44.4781 175.277 44.5392C175.285 44.6002 175.307 44.6586 175.342 44.7095C175.377 44.7605 175.423 44.8026 175.476 44.8325C175.678 44.9391 175.89 45.0248 176.109 45.0881C176.348 45.1649 176.581 45.2567 176.808 45.363C176.99 45.4525 177.15 45.583 177.273 45.7443C177.409 45.9289 177.479 46.1543 177.469 46.3834C177.472 46.6242 177.405 46.8606 177.277 47.0641C177.139 47.2759 176.945 47.4446 176.716 47.551C176.446 47.678 176.149 47.7403 175.85 47.7331C175.552 47.7368 175.256 47.6829 174.978 47.5744Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.819 43.3024V44.1546H183.008V45.0781H184.362V45.909H183.008V47.6826H181.927V43.3002L184.819 43.3024Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.131 47.4427C189.788 47.255 189.502 46.9783 189.302 46.6416C189.102 46.2889 188.997 45.8903 188.997 45.4848C188.997 45.0792 189.102 44.6806 189.302 44.3279C189.502 43.9922 189.788 43.7165 190.131 43.53C190.484 43.3409 190.879 43.242 191.279 43.242C191.68 43.242 192.074 43.3409 192.427 43.53C192.769 43.7149 193.054 43.9911 193.249 44.3279C193.447 44.6813 193.551 45.0796 193.551 45.4848C193.551 45.8899 193.447 46.2882 193.249 46.6416C193.053 46.9784 192.769 47.2554 192.427 47.4427C192.074 47.6318 191.681 47.7307 191.281 47.7307C190.881 47.7307 190.487 47.6318 190.134 47.4427H190.131ZM192.13 46.4073C192.336 46.1429 192.448 45.817 192.448 45.4816C192.448 45.1461 192.336 44.8203 192.13 44.5559C191.901 44.3356 191.595 44.2125 191.277 44.2125C190.96 44.2125 190.654 44.3356 190.425 44.5559C190.218 44.8212 190.106 45.1482 190.106 45.4848C190.106 45.8214 190.218 46.1483 190.425 46.4136C190.653 46.6359 190.959 46.7603 191.277 46.7603C191.596 46.7603 191.902 46.6359 192.13 46.4136V46.4073Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.208 47.6918L199.285 46.0375H199.026V47.6918H197.944V43.3094H199.755C200.063 43.3008 200.369 43.3628 200.65 43.4905C200.88 43.5957 201.073 43.7685 201.203 43.9858C201.327 44.1993 201.39 44.4422 201.387 44.6889C201.391 44.9691 201.303 45.2428 201.137 45.4686C200.953 45.7094 200.693 45.881 200.4 45.9554L201.424 47.6907L200.208 47.6918ZM199.026 45.2822H199.696C199.857 45.2943 200.018 45.2427 200.142 45.1384C200.194 45.0849 200.234 45.0212 200.26 44.9513C200.285 44.8814 200.296 44.8069 200.291 44.7325C200.295 44.6601 200.284 44.5876 200.258 44.5197C200.232 44.4518 200.193 44.3901 200.142 44.3384C200.018 44.2341 199.857 44.1825 199.696 44.1946H199.026V45.2822Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M210.89 43.3086V47.691H209.809V45.063L208.815 47.691H207.943L206.944 45.0567V47.691H205.862V43.3086H207.141L208.386 46.3424L209.619 43.3086H210.89Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M218.223 46.9166H216.563L216.297 47.691H215.166L216.772 43.3086H218.024L219.63 47.691H218.486L218.223 46.9166ZM217.945 46.0921L217.396 44.4878L216.851 46.0921H217.945Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M227.108 43.3086V44.1608H225.937V47.6878H224.855V44.1608H223.684V43.3086H227.108Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232.528 43.3086V47.691H231.447V43.3086H232.528Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M238.059 47.4427C237.715 47.2553 237.429 46.9785 237.23 46.6416C237.029 46.2892 236.923 45.8905 236.923 45.4848C236.923 45.079 237.029 44.6803 237.23 44.3279C237.429 43.9919 237.715 43.7162 238.059 43.53C238.412 43.3409 238.806 43.242 239.206 43.242C239.607 43.242 240.001 43.3409 240.354 43.53C240.696 43.7152 240.981 43.9913 241.176 44.3279C241.375 44.6813 241.479 45.0796 241.479 45.4848C241.479 45.8899 241.375 46.2882 241.176 46.6416C240.98 46.9782 240.696 47.2551 240.354 47.4427C240.002 47.6318 239.608 47.7307 239.208 47.7307C238.808 47.7307 238.414 47.6318 238.062 47.4427H238.059ZM240.056 46.4073C240.263 46.1432 240.376 45.8172 240.376 45.4816C240.376 45.1459 240.263 44.82 240.056 44.5559C239.947 44.4401 239.815 44.3492 239.668 44.2895C239.521 44.2297 239.362 44.2025 239.204 44.2097C239.045 44.2029 238.887 44.23 238.74 44.2892C238.594 44.3483 238.461 44.4382 238.351 44.5527C238.144 44.8179 238.031 45.1449 238.031 45.4816C238.031 45.8182 238.144 46.1452 238.351 46.4104C238.46 46.5258 238.593 46.6164 238.74 46.6762C238.887 46.7359 239.045 46.7634 239.204 46.7567C239.363 46.7638 239.522 46.7362 239.669 46.6756C239.816 46.6151 239.949 46.5232 240.057 46.4062L240.056 46.4073Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M249.842 47.691H248.761L246.95 44.9874V47.691H245.869V43.3086H246.95L248.761 46.0239V43.3086H249.842V47.691Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6334 40.9196H77.5616L65.0865 25.5897V40.9196H60.4688V10.6274H65.0865V25.5162L76.9288 10.6274H82.5565L70.4916 25.2957L83.6334 40.9196Z",
    fill: "#2158A5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2041 40.9196V10.6274H104.861V14.8553H90.8209V24.7077H103.147V28.8983H90.8209V40.9196H86.2041Z",
    fill: "#2158A5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.956 40.9196V10.6274H113.574V40.9196H108.956Z",
    fill: "#2158A5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M119.458 40.9207V10.0032L140.763 31.2888C140.738 29.7449 140.713 28.2561 140.688 26.8223C140.663 25.3885 140.651 23.8506 140.651 22.2087V10.6285H145.158V41.6919L123.888 20.3339C123.912 21.8778 123.936 23.3912 123.962 24.874C123.987 26.3568 124 27.8698 123.999 29.413V40.9175L119.458 40.9207Z",
    fill: "#2158A5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M157.479 40.9196V14.8553H148.616V10.6274H171.034V14.8553H162.13V40.9196H157.479Z",
    fill: "#2158A5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M174.496 40.9196V10.6274H193.19V14.8191H179.188V23.422H190.845V27.5391H179.188V36.73H193.749V40.9206L174.496 40.9196Z",
    fill: "#2158A5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M211.959 41.5115C209.76 41.5277 207.578 41.1156 205.536 40.2982C203.598 39.5283 201.823 38.3996 200.304 36.9715C198.814 35.5598 197.619 33.8668 196.788 31.9904C195.941 30.0287 195.504 27.9144 195.504 25.7774C195.504 23.6405 195.941 21.5262 196.788 19.5644C197.62 17.6882 198.814 15.9952 200.304 14.5834C201.821 13.1572 203.597 12.0345 205.536 11.2758C207.593 10.4682 209.787 10.0625 211.997 10.0806C213.969 10.0475 215.933 10.346 217.807 10.9637C219.26 11.4392 220.648 12.0933 221.94 12.9109V18.1306C221.311 17.5418 220.625 17.0182 219.891 16.5679C219.111 16.0847 218.288 15.6725 217.434 15.3365C216.559 14.9918 215.656 14.7272 214.733 14.5461C213.821 14.3641 212.894 14.2717 211.964 14.2702C210.363 14.2537 208.775 14.5538 207.291 15.1533C205.909 15.7106 204.655 16.5418 203.604 17.5969C202.567 18.6481 201.745 19.8909 201.184 21.256C200.017 24.1575 200.017 27.3974 201.184 30.2988C201.745 31.6636 202.567 32.906 203.604 33.9569C204.655 35.0126 205.909 35.844 207.291 36.4005C208.775 37 210.363 37.3001 211.964 37.2836C213.846 37.2845 215.711 36.9229 217.456 36.2184C219.109 35.5832 220.631 34.6482 221.944 33.4605V38.6801C220.626 39.4857 219.22 40.1393 217.754 40.6285C215.886 41.2475 213.927 41.5461 211.959 41.5115Z",
    fill: "#2158A5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M227.078 40.9196V10.6274H231.691V23.3836H246.772V10.6274H251.398V40.9196H246.78V27.5753H231.691V40.9196H227.078Z",
    fill: "#2158A5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.875 46.7358L56.545 46.0466L57.0606 46.6122C57.11 46.6668 57.142 46.735 57.1524 46.808C57.1628 46.8809 57.1512 46.9553 57.119 47.0216C57.0868 47.0879 57.0356 47.143 56.9718 47.18C56.9081 47.2169 56.8347 47.234 56.7612 47.229L47.875 46.7358Z",
    fill: "url(#paint0_linear_1_645)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8776 1.10687L28.8482 6.96568L20.6789 35.5311L12.6523 37.7479L22.8776 1.10687Z",
    fill: "url(#paint1_linear_1_645)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24609 48.7304L3.10174 40.3864L32.9071 32.1319L39.3752 38.4424L1.24609 48.7304Z",
    fill: "url(#paint2_linear_1_645)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5064 15.2545L56.5462 46.0538L47.8762 46.743L24.0947 23.5399L26.5064 15.2545Z",
    fill: "url(#paint3_linear_1_645)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M3.10254 40.3864L32.9079 32.1319L39.376 38.4424L3.10254 40.3864Z",
    fill: "url(#paint4_linear_1_645)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M22.8776 1.10687L20.6789 35.5258L12.6523 37.7425L22.8776 1.10687Z",
    fill: "url(#paint5_linear_1_645)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M26.5075 15.2545L47.8762 46.743L24.0947 23.5399L26.5075 15.2545Z",
    fill: "url(#paint6_linear_1_645)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8486 6.96065L23.7354 0.148451C23.6924 0.091955 23.6342 0.0487828 23.5677 0.0238942C23.5011 -0.000994331 23.4289 -0.00657424 23.3593 0.00778627C23.2898 0.0221468 23.2257 0.0558678 23.1744 0.105068C23.1232 0.154268 23.0868 0.216947 23.0697 0.28588L22.8779 1.10823L28.8486 6.96065Z",
    fill: "url(#paint7_linear_1_645)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10161 40.3875L1.24596 48.7326L0.492837 48.9797C0.426294 49.0027 0.354619 49.0062 0.286132 48.99C0.217645 48.9738 0.155158 48.9385 0.105953 48.8881C0.0567486 48.8378 0.0228411 48.7746 0.0081679 48.7057C-0.00650531 48.6369 -0.00133304 48.5653 0.023073 48.4993L3.10161 40.3875Z",
    fill: "url(#paint8_linear_1_645)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_645",
    x1: 47.875,
    y1: 46.6382,
    x2: 57.1561,
    y2: 46.6382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#31ADB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#1693A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#058492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_645",
    x1: 25.9492,
    y1: 4.84425,
    x2: 4.91829,
    y2: 18.1042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#149ECC",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#1399C6",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#1089B6",
    stopOpacity: 0.945
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_645",
    x1: 0.292865,
    y1: 45.3941,
    x2: 16.5718,
    y2: 20.8729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#377FC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#357BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#2F71B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#2660AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2158A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_645",
    x1: 53.301,
    y1: 47.4357,
    x2: 27.3905,
    y2: 19.8903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#43BEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#39B5BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#28A5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#118F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_645",
    x1: 1.83297,
    y1: 44.8108,
    x2: 4.7074,
    y2: 29.3814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#377FC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#3379BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#2A68B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2158A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_645",
    x1: 25.3214,
    y1: 2.93866,
    x2: 7.95596,
    y2: 8.20121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#149ECC",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#1295C2",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#0E7BA8",
    stopOpacity: 0.976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_645",
    x1: 53.3221,
    y1: 46.3966,
    x2: 21.0779,
    y2: 28.8638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#41BCC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#30ADB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#1593A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_645",
    x1: 23.278,
    y1: 0.598616,
    x2: 29.6834,
    y2: 5.98126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D719D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#0E7BA8",
    stopOpacity: 0.976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#1295C2",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149ECC",
    stopOpacity: 0.898
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_645",
    x1: 0,
    y1: 44.6938,
    x2: 3.10161,
    y2: 44.6938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#377FC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#2D6EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#245DA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2158A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKfinLogo);
export default __webpack_public_path__ + "static/media/kfin-logo.32acd6179c49fcf0bde297c3ae68fa0f.svg";
export { ForwardRef as ReactComponent };